import React from "react";
import { useNavigate } from "react-router-dom";
import { Linkedin, Instagram, Youtube, Facebook } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "./Navbar";

const Footer = () => {
  const navigate = useNavigate();

  const links = [
    { label: "Partners", action: () => navigate("/") },
    { label: "Customise Cookie", action: () => toast.success("Cookie preferences saved.") },
    { label: "Careers", action: () => navigate("/careers") },
    { label: "Privacy Policy", action: () => navigate("/about") },
    { label: "Terms & Conditions", action: () => navigate("/about") },
    { label: "Contact Us", action: () => navigate("/contact") },
  ];

  return (
    <footer className="bg-[#040b1a] border-t border-white/10" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-14 pb-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <Logo />
          <nav className="flex flex-wrap items-center justify-center gap-x-9 gap-y-3">
            {links.map((l) => (
              <button
                key={l.label}
                onClick={l.action}
                className="text-white/75 hover:text-white text-[15px] transition-colors"
                data-testid={`footer-link-${l.label.replace(/\s|&/g, "").toLowerCase()}`}
              >
                {l.label}
              </button>
            ))}
          </nav>
          <div className="flex items-center gap-4">
            {[Linkedin, Instagram, Youtube, Facebook].map((Icon, i) => (
              <button key={i} aria-label="Social link" className="text-white/70 hover:text-white transition-colors">
                <Icon size={19} />
              </button>
            ))}
          </div>
        </div>
        <div className="border-t border-white/10 mt-10 pt-7 text-center">
          <p className="text-white/45 text-sm">© 2026 ZoofyTechX. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
